import { render, staticRenderFns } from "./MonitoringForm.vue?vue&type=template&id=71bec47e&scoped=true"
import script from "./MonitoringForm.vue?vue&type=script&lang=js"
export * from "./MonitoringForm.vue?vue&type=script&lang=js"
import style0 from "./MonitoringForm.vue?vue&type=style&index=0&id=71bec47e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bec47e",
  null
  
)

export default component.exports